// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/primeflex/primeflex.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/primeicons/primeicons.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#PorscheNextWLa-Thin" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#PorscheNextWLa-ThinItalic" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#PorscheNextWLa-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#PorscheNextWLa-Italic" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#PorscheNextWLa-Bold" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/* ==========================================================================
PrimeNG and it's third-party dependencies resources
========================================================================== */ 
/*@import 'primeng/resources/primeng.min.css';
@import 'primeng-extensions/resources/primeng-extensions.min.css'; */

@font-face {
  font-family: 'PorscheNextWLa';
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('svg');
}
@font-face {
  font-family: 'PorscheNextWLa';
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___})
      format('svg');
}
@font-face {
  font-family: 'PorscheNextWLa';
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___})
      format('svg');
}
@font-face {
  font-family: 'PorscheNextWLa';
  font-weight: normal;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___})
      format('svg');
}
@font-face {
  font-family: 'PorscheNextWLa';
  font-weight: bold;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('svg');
}
@font-face {
  font-family: 'PorscheNextWLa';
  font-weight: bold;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('svg');
}

table {
  height: 600px;
  display: -moz-groupbox;
}
tbody {
  /* overflow-y:scroll; */ /* height:560px; */ /* position: relative; */ /* border-bottom:.1em dotted grey; */
}
.cellGray {
  background-color: #b3b3b3;
}
.cellLightGray {
  background-color: #cecece;
}
.createBox {
  border: 1px dashed #000;
  background-color: #dee2e6;
  padding: 5px;
}
.fDivRow {
  content: '';
  display: table;
  clear: both;
}
.pT5 {
  padding-top: 5px;
}
.fDivCol {
  float: left;
  margin-right: 10px;
}
body,
h1,
h2,
h3,
h4 {
  font-weight: 400;
}
.pagination .page-item .page-link {
  border-radius: 0 !important;
}
.pagination .page-link {
  border-top-style: none !important;
  border-bottom-style: none !important;
  background-color: #f6f6f6 !important;
  color: #000 !important;
}
.btn-grey:hover {
  color: #fff;
  background-color: #a4a4a4;
  border-color: #a4a4a4;
}
.btn-grey {
  color: #fff;
  background-color: #cecace;
  border-color: #cecace;
}
.btn-blue:hover {
  color: #fff;
  background-color: #767ef5;
  border-color: #767ef5;
}
.btn-blue {
  color: #fff;
  background-color: #4853f0;
  border-color: #4853f0;
}
.btn-warning {
  color: #fff;
  background-color: #f39d12;
  border-color: #f39d12;
}
.btn-warning:hover {
  color: #fff;
  background-color: #d68708;
  border-color: #d68708;
}
.btn-success {
  color: #fff;
  background-color: #890012;
  border-color: #890012;
}
.btn-success-green {
  color: #fff;
  background-color: #6b8e23;
  border-color: #6b8e23;
}
.btn-success:hover {
  color: #fff;
  background-color: #3498db;
  border-color: #3498db;
}
.btn-success:disabled {
  color: #fff;
  background-color: #890012;
  border-color: #890012;
}
a {
  color: #000 !important;
}
a:hover {
  cursor: pointer;
  color: #d3d3d3 !important;
}
.bg-primary .navbar-nav .active > .nav-link,
a:active {
  color: #890012 !important;
}
.dropdown-item:hover {
  color: #fff;
}
.browserupgrade {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}
.jh-card {
  /* padding:1.5%; */
  margin-top: 20px;
  border: none;
}
.error {
  color: #fff;
  background-color: red;
}
.pad {
  padding: 10px;
}
.w-40 {
  width: 40% !important;
}
.w-60 {
  width: 60% !important;
}
.break {
  white-space: normal;
  word-break: break-all;
}
.readonly {
  background-color: #eee;
  opacity: 1;
}
.footer {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  font-size: 8px;
  position: relative;
  bottom: 0;
  height: 25px;
  padding: 3px;
  width: 100%;
}
.hand,
[jhisortby] {
  cursor: pointer;
}
.alerts .alert {
  text-overflow: ellipsis;
}
.alerts .alert pre {
  background: none;
  border: none;
  font: inherit;
  color: inherit;
  padding: 0;
  margin: 0;
}
.alerts .alert .popover pre {
  font-size: 10px;
}
.alerts .jhi-toast {
  position: fixed;
  width: 100%;
}
.alerts .jhi-toast.left {
  left: 5px;
}
.alerts .jhi-toast.right {
  right: 5px;
}
.alerts .jhi-toast.top {
  top: 55px;
}
.alerts .jhi-toast.bottom {
  bottom: 55px;
}
@media screen and (min-width: 480px) {
  .alerts .jhi-toast {
    width: 50%;
  }
}
.row.jh-entity-details > dd {
  margin-bottom: 15px;
}
@media screen and (min-width: 768px) {
  .row.jh-entity-details > dt {
    margin-bottom: 15px;
  }
  .row.jh-entity-details > dd {
    border-bottom: 1px solid #eee;
    padding-left: 180px;
    margin-left: 0;
  }
}
.carousel,
.nav,
.pagination,
.panel-title a {
  cursor: pointer;
}
.thread-dump-modal-lock {
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rowDiv {
  display: -webkit-box;
  display: flex;
}
.columnDiv {
  -webkit-box-flex: 40%;
  flex: 40%;
  border: 1px dotted #dfe2e7;
}
.leftDiv {
  width: 25%;
}
.rightDiv {
  width: 75%;
}

/*anna*/

/* General */

body,
h1,
h2,
h3 {
  color: #000 !important;
  font-weight: 400 !important;
  font-family: PorscheNextWLa, Arial Narrow, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 1.5;
}

h4 {
  font-size: 16px;
}

body a {
  text-decoration: none !important;
}

.bg-primary {
  background-color: white !important;
}

/*Navigation*/

/*Logo img*/

jhi-navbar > nav > a > span {
  background: url(https://kate-e.emea.porsche.biz/content/555295b649c93dda5e90268da4f0a5c9.svg);
  width: 123px !important;
  height: 75px !important;
  cursor: auto;
}

.navbar-brand.logo {
  margin-right: 0;
}

/*Hide text next to logo img*/

.navbar-title,
.navbar-version {
  display: none;
}

/*Align navbar to left*/

nav.navbar.navbar-primary {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.navbar-collapse.collapse {
  align-self: flex-start;
  margin-top: 20px;
}

/* Align Login to right */
.collapse.right-alligned {
  align-self: flex-end;
  margin-top: -32px;
  margin-right: 5px;
}

/*Remove icons next to navbar elements*/

.navbar .ng-fa-icon,
.dropdown-toggle:after {
  display: none;
}

/*Styling of navigation items*/

.nav-item.pointer.active.dropdown a,
.nav-item.pointer.dropdown a,
.navbar-nav.ml-auto li,
.aNB.navbar-brand.logo {
  font-weight: 400 !important;
  color: #000 !important;
  font-size: 1rem;
}

.nav-item.pointer.active.dropdown a:hover,
.nav-item.pointer.dropdown a:hover,
.navbar-nav.ml-auto li:hover,
.aNB.navbar-brand.logo:hover {
  color: #d5001c !important;
}

.nav-item {
  padding-bottom: 0.58rem;
}

.nav-item.active {
  border-bottom: 2px solid #d5001c;
}

/*Styling of navigation dropdowns */

ul.dropdown-menu.show li a.dropdown-item,
ul.dropdown-menu.show li a.dropdown-item.active {
  display: block;
  padding: 0.625em 0.9375em;
  font-weight: 400;
  border-bottom: 1px solid #e3e4e4;
  transition: background-color 0.24s, color 0.24s, border-color 0.24s;
  background-color: #fff !important;
}

ul.dropdown-menu.show li a.dropdown-item:hover,
ul.dropdown-menu.show li a.dropdown-item:hover,
ul.dropdown-menu.show li a.dropdown-item.active:hover,
.nav-item.pointer.active.show.dropdown ul a:hover {
  background-color: #d5001c !important;
  color: #fff !important;
}

ul.dropdown-menu.show {
  padding: 0;
  margin-top: 10px;
}

/*Header*/

/*Align elements of header*/

h2 {
  display: flex;
  flex-direction: column;
}

/*Styling of header line */

jhi-audit h2,
jhi-logs > .table-responsive > h2,
jhi-configuration > div > h2,
h2 > span {
  background-color: #f2f2f2;
  width: calc(100% + 40px);
  padding: 10px 30px;
  margin: 0 -20px 10px;
  font-size: 24px;
}

.component-title {
  padding: 20px 30px !important;
  font-weight: 300;
}

/*Align header with navigation */

.jh-card {
  margin-top: 0;
  padding-top: 0;
}

/*Home*/

/*Remove all text elements*/

jhi-home > .row > .col-md-3 {
  display: none;
}

jhi-home > .row > .col-md-9 h1,
jhi-home > .row > .col-md-9 div,
jhi-home > .row > .col-md-9 p,
jhi-home > .row > .col-md-9 ul {
  display: none;
}

/*Styling of text elements on login modal */

jhi-home .alert.alert-warning,
jhi-login-modal .alert.alert-warning {
  background-color: #e3e4e5;
}

jhi-home .alert.alert-warning a:hover,
jhi-login-modal .alert.alert-warning a:hover {
  color: #000;
  font-weight: bold;
}

jhi-home .alert.alert-warning,
jhi-home .alert.alert-warning a,
jhi-login-modal .alert.alert-warning,
jhi-login-modal .alert.alert-warning a {
  font-size: 14px;
  color: #000 !important;
  font-family: PorscheNextWLa, Arial Narrow, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 1.5;
}

/*Buttons&Badges*/

/*General*/

.btn,
.swal2-styled.swal2-cancel {
  border-radius: 0px !important;
}

/*Primary button red/white*/

.btn.btn-primary,
.btn.btn-danger,
jhi-body-planing-detail .btn.btn-success-green {
  border-radius: 0px !important;
  color: #fff;
  background-color: #d5001c;
  border: 1px solid #d5001c;
  box-shadow: none;
  width: auto !important;
  height: auto !important;
  padding: 0.375rem 0.75rem !important;
}

.btn.btn-primary:hover,
.btn.btn-primary:active,
.btn.btn-primary:focus,
.btn-primary:not(:disabled):not(.disabled):active,
.btn.btn-danger:active,
.btn.btn-danger:focus,
.btn.btn-danger:hover,
jhi-body-planing-detail .btn.btn-success-green:hover {
  background-color: #950014;
  color: #fff;
  border-color: #950014;
  box-shadow: none !important;
}

.btn.btn-danger:disabled {
  color: #fff;
  background-color: #d5001c;
  border: 1px solid #d5001c;
}

button.btn.btn-primary.btn-sm:disabled,
button.btn.btn-grey.btn-sm:disabled,
button.btn.btn-warning.btn-sm:disabled,
button.btn.btn-primary.btn-sm:hover:disabled,
button.btn.btn-grey.btn-sm:hover:disabled,
button.btn.btn-warning.btn-sm:hover:disabled {
  color: #323639;
  background-color: #fff !important;
  border-color: #323639;
  opacity: 0.3;
}

/*Seconday button white/black*/

.btn.btn-info,
.btn.btn-primary.btn-sm,
.btn.btn-info.btn-sm,
.btn.btn-success-green,
.btn.btn-blue.btn-sm,
.btn.btn-grey.btn-sm,
.swal2-confirm.swal2-styled,
.btn.btn-secondary,
.table-responsive.createBox .btn.btn-danger,
.btn.btn-secondary,
.swal2-styled.swal2-cancel {
  color: #323639;
  background-color: #fff;
  border-color: #323639;
  transition: all 0.2s;
  width: auto !important;
  height: auto !important;
  padding: 0.375rem 0.75rem !important;
}

jhi-c-nr-vds-type-code-exception .btn.btn-success-green {
  color: #fff;
  background-color: #018a16;
  border: none !important;
  width: auto !important;
  height: auto !important;
  padding: 0.375rem 0.75rem !important;
}

jhi-c-nr-vds-type-code-exception .btn.btn-success-green:hover {
  background-color: #018a16;
  color: #fff;
}

.btn.btn-info:hover,
.btn.btn-info.btn-sm:hover,
.btn.btn-primary.btn-sm:hover,
.btn.btn-info.btn-sm:hover,
.btn.btn-blue.btn-sm:hover,
.btn.btn-grey.btn-sm:hover,
.btn.btn-success-green:hover,
.swal2-confirm.swal2-styled:hover,
.btn-info:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn.btn-secondary:hover,
.table-responsive.createBox .btn.btn-danger:hover,
.btn.btn-secondary:hover {
  background-color: #fff;
  color: #d5001c;
  border-color: #d5001c;
  box-shadow: none;
}

/* Black Button */

h2 .btn.btn-primary.float-right.jh-create-entity,
.btn.btn-warning.btn-sm:active,
.btn.btn-warning.btn-sm:focus,
.btn.btn-grey.btn-sm:active,
.btn.btn-grey.btn-sm:focus {
  border-radius: 0;
  min-width: 3rem;
  min-height: 3rem;
  width: fit-content;
  background-color: #323639;
  border: 1px solid #323639;
  color: #fff;
  align-self: flex-end;
  box-shadow: none !important;
  margin-top: -72px;
}

h2 .btn.btn-primary.float-right.jh-create-entity:hover,
.btn.btn-warning.btn-sm:hover,
.swal2-styled.swal2-cancel:hover {
  background-color: #d5001c !important;
  color: #fff;
  border-color: #d5001c;
}

/*Layout btn group*/
.btn-group > .btn-sm {
  margin-top: 0px;
  min-width: 3rem !important;
  min-height: 3rem !important;
  font-size: 16px;
}

.btn-sm,
.btn-danger,
.btn.btn-info {
  margin-top: 0px;
  font-size: 15px;
  padding: 0px;
}

.btn-group > .btn-sm,
.btn-group.btn.btn-info.btn-sm {
  margin: 0 10px 0 0;
}

.btn.focus,
button:focus {
  outline: 0 !important;
  box-shadow: none;
}

.btn.btn-info.btn-sm > .d-none.d-md-inline,
.btn > .d-none.d-md-inline {
  display: none !important;
}

.create-planing-circle-data {
  font-size: 16px;
}

.btn.btn-danger.float-right.jh-create-entity.create-planing-circle-data > fa-icon,
.btn.btn-success-green.float-right.jh-create-entity.create-planing-circle-data > fa-icon {
  padding-right: 5px;
}

.btn.btn-danger.float-right.jh-create-entity.create-planing-circle-data {
  width: auto !important;
  padding: 0.375rem 0.75rem;
  height: auto;
}

.swal2-styled.swal2-cancel,
.swal2-confirm.swal2-styled {
  font-size: 16px !important;
}

jhi-type-e > div > .btn.btn-info.btn-sm,
jhi-model-e > div > .btn.btn-info.btn-sm {
  margin-bottom: 2px !important;
}

jhi-type-e > div > .btn.btn-danger,
jhi-model-e > div > .btn.btn-danger,
jhi-monitoring .btn.btn-danger {
  height: 2em;
  width: 2em;
  padding: 0px;
  margin-bottom: 2px !important;
  border: 1px solid #d5001c;
}

jhi-logs .btn,
jhi-logs .btn.btn-sm.btn-warning {
  width: auto !important;
  height: auto !important;
  padding: 0px;
}

jhi-logs .btn.btn-sm,
jhi-logs .btn.btn-info.btn-sm {
  color: #212529;
  padding: 0px !important;
}

.badge {
  border-radius: 0;
  font-size: 12px;
}

.badge.badge-warning {
  background-color: #ff9b00;
}

.badge.badge-danger {
  background-color: #e00000;
}

.badge.badge-success {
  background-color: #018a16;
}

.badge {
  background-color: #b0b1b2;
}

/*Table*/

hr {
  display: none;
}

table {
  height: auto;
  table-layout: fixed;
}

.table-responsive {
  margin-top: 30px;
  word-break: break-word;
  width: 100%;
  height: auto;
  position: relative !important;
  overflow: unset;
}

tbody {
  border-bottom: 0;
}

tbody::-webkit-scrollbar {
  width: 10px;
}

tbody::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

tbody::-webkit-scrollbar-track {
  background-color: #fff;
}

thead {
  display: block;
}

.table thead tr th {
  font-weight: 400;
  color: #000;
  background-color: #eff0f1 !important;
  word-break: break-all;
  position: sticky;
  top: 0;
  z-index: 2;
}

jhi-monitoring .table tr,
jhi-body-planing-data .table tr {
  width: 100%;
  display: table-row;
  table-layout: auto;
}

th > span {
  padding-right: 5px;
}

.table-responsive td {
  background-color: #fff;
  vertical-align: middle;
}

.table-responsive th {
  border: 0px !important;
}

/*Pagination*/

jhi-item-count {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  background-color: white;
}

ngb-pagination {
  flex-grow: 1;
  display: flex;
  justify-content: center;
}

.row.justify-content-center,
.pagination .page-link {
  background-color: #eff0f1 !important;
  color: #848484 !important;
}

.page-item.active a {
  border-bottom: 2px solid #d5001c !important;
}

.info.jhi-item-count {
  padding: 10px;
}

.pagination {
  margin: 0;
  padding: 8px;
}

.page-link:focus {
  box-shadow: none;
}

/*Footer*/

.footer {
  margin-top: 50px;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  font-size: 16px;
}

/* Form Elements */

input,
select,
.form-control {
  border-radius: 0 !important;
  /* padding: .429em 32px .429em .429em; */
  color: #000;
  border: 1px solid #a6a6a6 !important;
  font-size: 16px;
  /* max-height: 2em; */
  padding-top: 0;
  padding-bottom: 0;
}

input:focus,
select:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid #a6a6a6 !important;
  background-color: #fff;
  outline: 0;
  box-shadow: none !important;
}

input:-internal-autofill-selected {
  background-color: #fff !important;
}

.col-8 > .ng-untouched.ng-pristine.ng-valid {
  border: none !important;
}

/* Search */

jhi-search-vehicle .normal-component-title,
jhi-search-vehicle-multiple .normal-component-title,
jhi-lock-vin .normal-component-title,
jhi-reserve-vin .normal-component-title,
jhi-manual-vin-adjustment .normal-component-title,
jhi-search-archived-vehicle .normal-component-title,
jhi-monitoring .normal-component-title {
  font-weight: 300;
}

jhi-search-vehicle .component-description,
jhi-search-vehicle-multiple .component-description,
jhi-reserve-vin .component-description,
jhi-manual-vin-adjustment .component-description,
jhi-search-archived-vehicle .component-description {
  background-color: transparent;
  font-size: 16px;
  margin-top: -10px;
  margin-bottom: 0px;
}

jhi-search-vehicle h4,
jhi-search-vehicle-multiple h4,
jhi-search-archived-vehicle h4,
jhi-manual-vin-adjustment h4 {
  padding-bottom: 20px;
}

jhi-search-vehicle .row {
  display: flex;
  align-items: center;
}

jhi-search-vehicle-multiple .row {
  display: flex;
  align-items: center;
}

.row > .form-group.col-2.offset-4.text-right {
  margin: 0px;
  display: flex;
  justify-content: flex-start;
}

.form-group.col-2.offset-4.text-right > .btn {
  margin-right: 10px;
}

/* Planing-circle-data */

.controls-container {
  align-self: flex-end;
  margin-top: -67px;
}

span.float-right.spinner {
  margin-top: -15px;
}

/*Update & Detail View/
		/*Body Planning*/
/*CNr-VDS-Typecode-Exception*/
/*CNr&VDS*/
/*Model*/

/*Modelyear*/

span.jhi-modelyear-info {
  background-color: transparent;
  font-size: 16px;
  margin-top: 15px;
  margin-bottom: -25px;
}

li.jhi-modelyear-info {
  background-color: transparent;
  font-size: 16px;
  margin-top: 15px;
  margin-bottom: -25px;
}


/*Password*/
/*Plant*/
/*Settings*/
/*Type*/

jhi-body-planing-data-update h2 > span,
jhi-body-planing-data-update h2,
jhi-body-planing-update h2 > span,
jhi-body-planing-update h2,
jhi-body-planing-detail h2 > span,
jhi-body-planing-detail h2,
jhi-body-planing-data-detail h2 > span,
jhi-body-planing-data-detail h2,
jhi-c-nr-vds-type-code-exception-update h2 > span,
jhi-c-nr-vds-type-code-exception-update h2,
jhi-c-nr-vds-type-code-exception-detail h2 > span,
jhi-c-nr-vds-type-code-exception-detail h2,
jhi-c-nr-vds-type-code-update h2 > span,
jhi-c-nr-vds-type-code-update h2,
jhi-c-nr-vds-type-code-detail h2 > span,
jhi-c-nr-vds-type-code-detail h2,
jhi-model-e-update h2 > span,
jhi-model-e-update h2,
jhi-model-e-detail h2 > span,
jhi-model-e-detail h2,
jhi-model-year-update h2 > span,
jhi-model-year-update h2,
jhi-model-year-detail h2 > span,
jhi-model-year-detail h2,
jhi-password h2,
jhi-plant-update h2 > span,
jhi-plant-update h2,
jhi-plant-detail h2 > span,
jhi-plant-detail h2,
jhi-settings h2,
jhi-type-e-update h2 > span,
jhi-type-e-update h2,
jhi-type-e-detail h2 > span,
jhi-type-e-detail h2 {
  display: flex;
  flex-direction: row;
  font-size: 24px;
  margin: 0px;
  padding: 0px;
  width: fit-content;
}

jhi-body-planing-data-update h2 > span,
jhi-body-planing-update h2 > span,
jhi-body-planing-detail h2 > span,
jhi-body-planing-data-detail h2 > span,
jhi-c-nr-vds-type-code-exception-update h2 > span,
jhi-c-nr-vds-type-code-exception-detail h2 > span,
jhi-c-nr-vds-type-code-update h2 > span,
jhi-c-nr-vds-type-code-detail h2 > span,
jhi-model-e-update h2 > span,
jhi-model-e-detail h2 > span,
jhi-model-year-update h2 > span,
jhi-model-year-detail h2 > span,
jhi-plant-update h2 > span,
jhi-plant-detail h2 > span,
jhi-type-e-update h2 > span,
jhi-type-e-detail h2 > span {
  padding-right: 10px;
}

jhi-body-planing-data-update .row.justify-content-center,
jhi-body-planing-update .row.justify-content-center,
jhi-body-planing-detail .row.justify-content-center,
jhi-body-planing-data-detail .row.justify-content-center,
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center,
jhi-c-nr-vds-type-code-exception-detail .row.justify-content-center,
jhi-c-nr-vds-type-code-update .row.justify-content-center,
jhi-c-nr-vds-type-code-detail .row.justify-content-center,
jhi-model-e-update .row.justify-content-center,
jhi-model-e-detail .row.justify-content-center,
jhi-model-year-update .row.justify-content-center,
jhi-model-year-detail .row.justify-content-center,
jhi-password .row.justify-content-center,
jhi-plant-update .row.justify-content-center,
jhi-plant-detail .row.justify-content-center,
jhi-settings .row.justify-content-center,
jhi-type-e-update .row.justify-content-center,
jhi-type-e-detail .row.justify-content-center {
  padding-top: 10px;
  padding-bottom: 20px;
}

jhi-body-planing-data-update dl,
jhi-body-planing-detail dl,
jhi-body-planing-data-detail dl,
jhi-c-nr-vds-type-code-exception-detail dl,
jhi-model-e-detail dl,
jhi-model-year-detail dl,
jhi-plant-detail dl,
jhi-type-e-detail dl {
  color: #000;
  font-size: 16px;
  margin-top: 16px;
}

jhi-body-planing-data-update button,
jhi-body-planing-update button,
jhi-body-planing-detail button,
jhi-body-planing-data-detail button,
jhi-c-nr-vds-type-code-exception-update button,
jhi-c-nr-vds-type-code-exception-detail button,
jhi-c-nr-vds-type-code-update button,
jhi-c-nr-vds-type-code-detail button,
jhi-model-e-update button,
jhi-model-e-detail button,
jhi-model-year-update button,
jhi-model-year-detail button,
jhi-plant-update button,
jhi-plant-detail button,
jhi-typel-e-update button,
jhi-model-e-detail button {
  margin-right: 8px;
}

jhi-body-planing-data-update .ng-fa-icon,
jhi-body-planing-update .ng-fa-icon,
jhi-body-planing-detail .ng-fa-icon,
jhi-body-planing-data-detail .ng-fa-icon,
jhi-c-nr-vds-type-code-exception-update .ng-fa-icon,
jhi-c-nr-vds-type-code-exception-detail button .ng-fa-icon,
jhi-c-nr-vds-type-code-update .ng-fa-icon,
jhi-c-nr-vds-type-code-detail button .ng-fa-icon,
jhi-model-e-update .ng-fa-icon,
jhi-model-e-detail button .ng-fa-icon,
jhi-model-year-update button > .ng-fa-icon,
jhi-model-year-detail button > .ng-fa-icon,
jhi-plant-update button > .ng-fa-icon,
jhi-plant-detail button > .ng-fa-icon,
jhi-type-e-update .ng-fa-icon,
jhi-type-e-detail button .ng-fa-icon {
  display: none;
}

jhi-body-planing-data-update .fDivRow,
jhi-model-e-update .fDivRow,
jhi-model-year-update .fDivRow,
jhi-plant-update .fDivRow,
jhi-type-e-update .fDivRow {
  margin-top: 16px;
  padding-bottom: 16px;
}

jhi-body-planing-data-update .form-control-label,
jhi-body-planing-update .form-control-label,
jhi-body-planing-detail .form-group label,
jhi-c-nr-vds-type-code-exception-update .form-control-label,
jhi-c-nr-vds-type-code-exception-update .form-group label,
jhi-c-nr-vds-type-code-update .form-control-label,
jhi-c-nr-vds-type-code-update .form-group label,
jhi-model-e-update .form-control-label,
jhi-model-e-update .form-group label,
jhi-model-year-update .form-control-label,
jhi-model-year-update .form-group label,
jhi-password label,
jhi-plant-update .form-control-label,
jhi-plant-update .form-group label,
jhi-settings label,
jhi-type-e-update .form-control-label,
jhi-type-e-update .form-group label {
  color: #000;
  font-size: 16px;
}

jhi-body-planing-data-update .form-group,
jhi-model-e-update .form-group,
jhi-model-year-update .form-group,
jhi-password .form-group,
jhi-plant-update .form-group,
jhi-settings .form-group,
jhi-type-e-update .form-group {
  padding-top: 8px;
}

jhi-body-planing-data-update .alert.alert-danger.alert-dismissible,
jhi-body-planing-update .alert.alert-danger.alert-dismissible,
jhi-c-nr-vds-type-code-exception-update .alert.alert-danger.alert-dismissible,
jhi-c-nr-vds-type-code-update .alert.alert-danger.alert-dismissible,
jhi-model-e-update .alert.alert-danger.alert-dismissible,
jhi-model-year-update .alert.alert-danger.alert-dismissible,
jhi-plant-update .alert.alert-danger.alert-dismissible,
jhi-type-e-update .alert.alert-danger.alert-dismissible {
  margin-top: 16px;
  background-color: #e00000;
}

.modal-content {
  border-radius: 0px;
}

jhi-model-e-update .btn.btn-danger,
jhi-model-e-update .fDivCol .btn.btn-primary,
jhi-model-e .table-responsive.createBox .btn.btn-danger,
jhi-model-year-update .btn.btn-danger,
jhi-model-year-update .fDivCol .btn.btn-primary,
jhi-type-e-update .btn.btn-danger,
jhi-type-e-update .fDivCol .btn.btn-primary,
jhi-type-e .fDivCol.pT5 .btn.btn-primary.btn-sm {
  display: none;
}

jhi-password-strength-bar div {
  color: #000;
  margin-top: 16px;
}

jhi-model-e .table-responsive.createBox,
jhi-type-e .table-responsive.createBox {
  background-color: #f2f2f2;
  width: calc(100% + 40px);
  padding: 10px 20px;
  margin: 0 -20px 80px;
  font-size: 24px;
  border: none;
}

jhi-model-e .table-responsive.createBox .d-none.d-md-inline,
jhi-type-e .table-responsive.createBox .d-none.d-md-inline {
  font-size: 24px;
  margin: 0px;
  padding: 0px;
  width: fit-content;
}

jhi-model-e .table-responsive.createBox label,
jhi-type-e .table-responsive.createBox label {
  color: #000;
  font-size: 16px;
}

.table-responsive.createBox .btn.btn-primary .ng-fa-icon,
.table-responsive.createBox .btn.btn-secondary .ng-fa-icon,
.table-responsive.createBox .btn.btn-primary .ng-fa-icon,
.table-responsive.createBox .btn.btn-secondary .ng-fa-icon {
  display: none;
}

jhi-model-e .table-responsive.createBox .form-text.text-danger,
jhi-type-e .table-responsive.createBox .form-text.text-danger {
  font-size: 12px;
}

jhi-model-e-update .col-8 > .ng-untouched.ng-pristine.ng-valid,
jhi-type-e-update .col-8 > .ng-untouched.ng-pristine.ng-valid {
  border: 0px;
}

jhi-type-e .table-responsive.createBox .btn.btn-danger {
  display: none;
}

jhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(4) label,
jhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(5) label,
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(6) label,
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(7) label,
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(8) label {
  white-space: nowrap;
  margin-bottom: 0;
  width: 100px;
}

jhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(4),
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(6) {
  padding-top: 20px;
}

jhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(5),
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(8) {
  padding-bottom: 20px;
}

jhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(4),
jhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(5),
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(6),
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(7),
jhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(8) {
  display: flex;
  align-items: center;
}

jhi-c-nr-vds-type-code-update select {
  max-height: none;
}

jhi-body-planing-data h2 span:first-child {
  margin-bottom: 20px;
}

jhi-body-planing-data h2 span:nth-child(2n) {
  margin-bottom: 10px;
}

jhi-body-planing-data > div > .btn.btn-info.btn-sm {
  position: absolute;
  margin-top: 20px;
  margin-left: 340px;
  display: flex;
  align-self: flex-end;
}

/* Model-e */

jhi-model-e .table-responsive,
jhi-type-e .table-responsive {
  margin-top: 10px;
}

jhi-planing-circle-data .table-responsive,
jhi-body-planing-data .table-responsive {
  margin-top: -10px;
}

.search-box {
  margin-top: 25px;
}

input#searchTextId {
  height: 36px;
  top: -1px;
  position: relative;
}

/*Lock VIN*/

jhi-lock-vin div h4 select {
  margin-top: 15px;
  margin-bottom: 20px;
  width: 20% !important;
}

jhi-lock-vin .not-available-title,
jhi-reserve-vin .not-available-title {
  margin-bottom: 10px;
  margin-top: -10px;
}

jhi-lock-vin div form .row:nth-child(1) {
  padding-top: 40px !important;
}

jhi-lock-vin div form .row:nth-child(3) {
  padding-bottom: 40px !important;
}

jhi-lock-vin div form .row {
  background-color: #f2f2f2;
}

jhi-lock-vin .mb-2 {
  margin-bottom: 0 !important;
}

/*Reserve VIN*/
/*Lock VIN*/

jhi-lock-vin h4 span,
jhi-reserve-vin h4 span {
  font-weight: 400;
}

jhi-reserve-vin div h4 select {
  margin-top: 15px;
  margin-bottom: 20px;
  width: 20% !important;
}

jhi-reserve-vin div form .row:nth-child(1) {
  padding-top: 40px !important;
}

jhi-reserve-vin div form .row:nth-child(3) {
  padding-bottom: 40px !important;
}

jhi-reserve-vin div form .row {
  background-color: #f2f2f2;
}

jhi-reserve-vin .mb-2 {
  margin-bottom: 0 !important;
}

/* Body-Planing-Data */
.title-container {
  background-color: #f2f2f2;
  width: calc(100% + 40px);
  padding: 20px 30px;
  margin: 0 -20px 10px;
  font-size: 24px;
}

/*Monitoring*/

jhi-monitoring .columnDiv {
  border: none;
  padding-top: 20px;
  height: fit-content;
}

jhi-monitoring h2 img {
  display: none;
}

jhi-monitoring .autocomplete-container {
  margin-top: 10px;
}

/*User Management*/

jhi-user-mgmt .btn.btn-success.btn-sm {
  padding-right: 8px;
  padding-left: 8px;
  background-color: #000;
  border: none;
}

jhi-user-mgmt .btn.btn-success.btn-sm:hover {
  background-color: #d5001c;
}

/*Audit*/

jhi-audit .input-group.mb-3 {
  align-items: center;
}

jhi-audit .input-group-text {
  border-radius: 0;
  max-height: 2em;
}

/*Modal*/

.swal2-popup.swal2-modal,
.modal-body,
.modal-header,
.swal2-html-container {
  border-radius: 0px;
  padding: 15px;
}

.modal-body {
  margin-top: 20px;
}

.swal2-popup.swal2-modal.swal2-icon-warning.swal2-show {
  padding: 0px;
}

.swal2-icon.swal2-warning.swal2-icon-show {
  display: none !important;
}

.modal-body > .row.justify-content-center {
  margin: 0;
  background-color: #fff !important;
}

h2.swal2-title,
.swal2-html-container {
  font-size: 16px;
  display: flex !important;
  align-self: start;
  margin: 0px;
}

.swal2-header,
.modal-header {
  background-color: #f4f4f4;
  color: #000;
  padding: 1em;
  font-weight: 700;
  border-bottom: 0;
}

.swal2-html-container {
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 16px;
}

.swal2-content {
  border-top: 1px solid #c8c8c8;
  border-bottom: 1px solid #c8c8c8;
  padding: 1em;
}

.swal2-actions {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.form-check {
  margin-top: 16px;
  margin-bottom: 16px;
}

.modal-content {
  border-radius: 0px;
}

.modal-footer .btn.btn-secondary .ng-fa-icon,
.modal-footer .btn.btn-danger .ng-fa-icon {
  display: none;
}

.swal2-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end !important;
}

.swal2-cancel.swal2-styled {
  margin-right: 15px;
}

.swal2-confirm.swal2-styled,
.swal2-styled:focus {
  border-radius: 0px !important;
  color: #fff !important;
  background-color: #d5001c !important;
  border: 1px solid #d5001c !important ;
  box-shadow: none !important;
  background-image: none !important;
}

.swal2-confirm.swal2-styled:hover {
  background-color: #950014 !important;
  color: #fff;
  border-color: #950014 !important;
  box-shadow: none;
}

.swal2-cancel.swal2-styled {
  border-radius: 0;
  color: #323639 !important;
  background-color: #fff !important;
  border: 1px solid !important;
  border-color: #323639 !important;
  transition: all 0.2s;
}

.swal2-cancel.swal2-styled:hover {
  background-color: #fff !important;
  color: #d5001c !important;
  border-color: #d5001c !important;
  border-radius: 0px !important;
  box-shadow: none;
  background-image: none !important;
}

/*Alert*/

.alert {
  border-radius: 0px !important;
  margin-top: 15px;
}

.alert.alert-warning {
  margin-top: 16px;
  background-color: #e00000;
  border-radius: 0px !important;
}

/* Autocomplete fields */
.p-autocomplete .p-autocomplete-dropdown.p-button {
  min-height: 34px;
  min-width: 29px;
  width: 1rem;
  height: 1rem;
  border-color: #a6a6a3 !important;
  background-color: #fff;
  transition: all 0.2s;
  border: 1px solid;
  border-left: 0;
}

.p-button.p-button-icon-only .p-button-text {
  padding: 0.429em;
}

input.p-inputtext.p-widget.ui-state-default.ui-corner-all.p-autocomplete-input {
  min-width: 225px;
}

p-autocomplete {
  margin-left: 15px;
  margin-right: 15px;
}

.p-autocomplete-items .p-autocomplete-list-item {
  margin: 0;
  padding: 0.429em 0.857em;
  border: 0;
  color: #000;
  border-radius: 0;
}

li.p-autocomplete-list-item.p-highlight {
  color: white;
  background-color: #d5001c;
}

ul.p-autocomplete-items.p-autocomplete-list.p-widget-content.p-widget.ui-corner-all.p-helper-reset {
  background-color: white;
}

ngb-modal-window {
  z-index: 1060 !important;
}

.p-autocomplete-items {
  background-color: white;
  border: 1px solid grey;
}

.p-autocomplete-item {
  padding: 5px;
  margin: 0;
}

.p-autocomplete-item:hover {
  background-color: #E0E0E0;
}

.btn-close {
  background-color: white;
  opacity: 40%;
  border: none;
}

.btn-close:hover {
  opacity: 30%;
}

.btn-close:before {
  content: "X";
  padding: 2px;
  margin-left: auto;
  order: 2;
}

ngb-alert {
  display: grid !important;
  grid-template-columns: 95% 5% !important;
  padding: 10px 0 10px 10px !important;
}

ul.p-autocomplete-multiple-container.p-component.p-inputtext.ng-star-inserted {
  padding-left: 5px;
  margin-bottom: 0 !important;
  border: 1px solid grey;
}

ul.p-autocomplete-multiple-container.p-component.p-inputtext.ng-star-inserted .p-autocomplete-token {
  border: 1px solid lightgrey;
  padding-right: 3px;
  padding-left: 3px;
  margin-right: 5px;
}

ul.p-autocomplete-multiple-container.p-component.p-inputtext.ng-star-inserted .p-autocomplete-token .p-autocomplete-token-label {
  margin-right: 15px;
  font-size: 14px;
}
li.p-autocomplete-input-chip input.p-autocomplete-input {
    border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/content/theme/theme.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;4EAE4E;AAI5E;oEACoE;;AAEpE;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,4CAA0G;EAC1G;;;;;yDAKyI;AAC3I;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,4CAAgH;EAChH;;;;;;mBAMiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6G;EAC7G;;;;;;mBAMiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,6CAA4G;EAC5G;;;;;;mBAMiB;AACnB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,6CAA0G;EAC1G;;;;;0DAKyI;AAC3I;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,6CAA0G;EAC1G;;;;;0DAKyI;AAC3I;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,oCAAoC;AAC7G;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;;;;;EAKE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;EAChB;AACF;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,OAAO;;AAEP,YAAY;;AAEZ;;;;EAIE,sBAAsB;EACtB,2BAA2B;EAC3B,qDAAqD;EACrD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,aAAa;;AAEb,WAAW;;AAEX;EACE,6FAA6F;EAC7F,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;;EAEE,aAAa;AACf;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,uCAAuC;;AAEvC;;EAEE,aAAa;AACf;;AAEA,8BAA8B;;AAE9B;;;;EAIE,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mCAAmC;;AAEnC;;EAEE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,mEAAmE;EACnE,iCAAiC;AACnC;;AAEA;;;;EAIE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,SAAS;;AAET,2BAA2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,0BAA0B;;AAE1B;;;;EAIE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,OAAO;;AAEP,2BAA2B;;AAE3B;EACE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA,2CAA2C;;AAE3C;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;EACf,sBAAsB;EACtB,qDAAqD;EACrD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB,UAAU;;AAEV;;EAEE,6BAA6B;AAC/B;;AAEA,2BAA2B;;AAE3B;;;EAGE,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,YAAY;AACd;;AAEA,8BAA8B;;AAE9B;;;;;;;;;;;EAWE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;EAcE,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;;EAGE,oCAAoC;EACpC,WAAW;EACX,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,QAAQ;;AAER;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,aAAa;;AAEb;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,SAAS;;AAET;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,kBAAkB;;AAElB;;;EAGE,2BAA2B;EAC3B,wCAAwC;EACxC,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,WAAW;;AAEX;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;EAKE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;kBACkB;AAClB,6BAA6B;AAC7B,UAAU;AACV,QAAQ;;AAER,YAAY;;AAEZ;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;;AAGA,WAAW;AACX,QAAQ;AACR,WAAW;AACX,OAAO;;AAEP;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;EAgBE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;;;EAQE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;EAgBE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;EAgBE,aAAa;AACf;;AAEA;;;;;EAKE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA,YAAY;;AAEZ;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,cAAc;AACd,WAAW;;AAEX;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,aAAa;;AAEb;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,QAAQ;;AAER;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,QAAQ;;AAER;;;;EAIE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,QAAQ;;AAER;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;IACI,uBAAuB;AAC3B","sourcesContent":["@charset \"UTF-8\";\n\n/* ==========================================================================\nPrimeNG and it's third-party dependencies resources\n========================================================================== */\n\n@import 'primeflex/primeflex.css';\n@import 'primeicons/primeicons.css'; \n/*@import 'primeng/resources/primeng.min.css';\n@import 'primeng-extensions/resources/primeng-extensions.min.css'; */\n\n@font-face {\n  font-family: 'PorscheNextWLa';\n  font-weight: 100;\n  font-style: normal;\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.eot');\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.eot?#iefix')\n      format('embedded-opentype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.woff2') format('woff2'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.woff') format('woff'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.ttf') format('truetype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Thin.svg#PorscheNextWLa-Thin') format('svg');\n}\n@font-face {\n  font-family: 'PorscheNextWLa';\n  font-weight: 100;\n  font-style: italic;\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.eot');\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.eot?#iefix')\n      format('embedded-opentype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.woff2') format('woff2'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.woff') format('woff'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.ttf') format('truetype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-ThinItalic.svg#PorscheNextWLa-ThinItalic')\n      format('svg');\n}\n@font-face {\n  font-family: 'PorscheNextWLa';\n  font-weight: normal;\n  font-style: normal;\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.eot');\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.eot?#iefix')\n      format('embedded-opentype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.woff2') format('woff2'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.woff') format('woff'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.ttf') format('truetype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Regular.svg#PorscheNextWLa-Regular')\n      format('svg');\n}\n@font-face {\n  font-family: 'PorscheNextWLa';\n  font-weight: normal;\n  font-style: italic;\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.eot');\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.eot?#iefix')\n      format('embedded-opentype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.woff2') format('woff2'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.woff') format('woff'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.ttf') format('truetype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Italic.svg#PorscheNextWLa-Italic')\n      format('svg');\n}\n@font-face {\n  font-family: 'PorscheNextWLa';\n  font-weight: bold;\n  font-style: normal;\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.eot');\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.eot?#iefix')\n      format('embedded-opentype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.woff2') format('woff2'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.woff') format('woff'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.ttf') format('truetype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.svg#PorscheNextWLa-Bold') format('svg');\n}\n@font-face {\n  font-family: 'PorscheNextWLa';\n  font-weight: bold;\n  font-style: italic;\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.eot');\n  src: url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/EOT-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.eot?#iefix')\n      format('embedded-opentype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-2-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.woff2') format('woff2'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/WOFF-TT/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.woff') format('woff'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/OT-TTF-Web/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.ttf') format('truetype'),\n    url('./fonts/Porsche_Next_Lat-Gr-Cyr_Web/SVG-PS/Porsche Next WebLatin/Fonts/PorscheNextWLa-Bold.svg#PorscheNextWLa-Bold') format('svg');\n}\n\ntable {\n  height: 600px;\n  display: -moz-groupbox;\n}\ntbody {\n  /* overflow-y:scroll; */ /* height:560px; */ /* position: relative; */ /* border-bottom:.1em dotted grey; */\n}\n.cellGray {\n  background-color: #b3b3b3;\n}\n.cellLightGray {\n  background-color: #cecece;\n}\n.createBox {\n  border: 1px dashed #000;\n  background-color: #dee2e6;\n  padding: 5px;\n}\n.fDivRow {\n  content: '';\n  display: table;\n  clear: both;\n}\n.pT5 {\n  padding-top: 5px;\n}\n.fDivCol {\n  float: left;\n  margin-right: 10px;\n}\nbody,\nh1,\nh2,\nh3,\nh4 {\n  font-weight: 400;\n}\n.pagination .page-item .page-link {\n  border-radius: 0 !important;\n}\n.pagination .page-link {\n  border-top-style: none !important;\n  border-bottom-style: none !important;\n  background-color: #f6f6f6 !important;\n  color: #000 !important;\n}\n.btn-grey:hover {\n  color: #fff;\n  background-color: #a4a4a4;\n  border-color: #a4a4a4;\n}\n.btn-grey {\n  color: #fff;\n  background-color: #cecace;\n  border-color: #cecace;\n}\n.btn-blue:hover {\n  color: #fff;\n  background-color: #767ef5;\n  border-color: #767ef5;\n}\n.btn-blue {\n  color: #fff;\n  background-color: #4853f0;\n  border-color: #4853f0;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f39d12;\n  border-color: #f39d12;\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: #d68708;\n  border-color: #d68708;\n}\n.btn-success {\n  color: #fff;\n  background-color: #890012;\n  border-color: #890012;\n}\n.btn-success-green {\n  color: #fff;\n  background-color: #6b8e23;\n  border-color: #6b8e23;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: #3498db;\n  border-color: #3498db;\n}\n.btn-success:disabled {\n  color: #fff;\n  background-color: #890012;\n  border-color: #890012;\n}\na {\n  color: #000 !important;\n}\na:hover {\n  cursor: pointer;\n  color: #d3d3d3 !important;\n}\n.bg-primary .navbar-nav .active > .nav-link,\na:active {\n  color: #890012 !important;\n}\n.dropdown-item:hover {\n  color: #fff;\n}\n.browserupgrade {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n.jh-card {\n  /* padding:1.5%; */\n  margin-top: 20px;\n  border: none;\n}\n.error {\n  color: #fff;\n  background-color: red;\n}\n.pad {\n  padding: 10px;\n}\n.w-40 {\n  width: 40% !important;\n}\n.w-60 {\n  width: 60% !important;\n}\n.break {\n  white-space: normal;\n  word-break: break-all;\n}\n.readonly {\n  background-color: #eee;\n  opacity: 1;\n}\n.footer {\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n  font-size: 8px;\n  position: relative;\n  bottom: 0;\n  height: 25px;\n  padding: 3px;\n  width: 100%;\n}\n.hand,\n[jhisortby] {\n  cursor: pointer;\n}\n.alerts .alert {\n  text-overflow: ellipsis;\n}\n.alerts .alert pre {\n  background: none;\n  border: none;\n  font: inherit;\n  color: inherit;\n  padding: 0;\n  margin: 0;\n}\n.alerts .alert .popover pre {\n  font-size: 10px;\n}\n.alerts .jhi-toast {\n  position: fixed;\n  width: 100%;\n}\n.alerts .jhi-toast.left {\n  left: 5px;\n}\n.alerts .jhi-toast.right {\n  right: 5px;\n}\n.alerts .jhi-toast.top {\n  top: 55px;\n}\n.alerts .jhi-toast.bottom {\n  bottom: 55px;\n}\n@media screen and (min-width: 480px) {\n  .alerts .jhi-toast {\n    width: 50%;\n  }\n}\n.row.jh-entity-details > dd {\n  margin-bottom: 15px;\n}\n@media screen and (min-width: 768px) {\n  .row.jh-entity-details > dt {\n    margin-bottom: 15px;\n  }\n  .row.jh-entity-details > dd {\n    border-bottom: 1px solid #eee;\n    padding-left: 180px;\n    margin-left: 0;\n  }\n}\n.carousel,\n.nav,\n.pagination,\n.panel-title a {\n  cursor: pointer;\n}\n.thread-dump-modal-lock {\n  max-width: 450px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rowDiv {\n  display: -webkit-box;\n  display: flex;\n}\n.columnDiv {\n  -webkit-box-flex: 40%;\n  flex: 40%;\n  border: 1px dotted #dfe2e7;\n}\n.leftDiv {\n  width: 25%;\n}\n.rightDiv {\n  width: 75%;\n}\n\n/*anna*/\n\n/* General */\n\nbody,\nh1,\nh2,\nh3 {\n  color: #000 !important;\n  font-weight: 400 !important;\n  font-family: PorscheNextWLa, Arial Narrow, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  line-height: 1.5;\n}\n\nh4 {\n  font-size: 16px;\n}\n\nbody a {\n  text-decoration: none !important;\n}\n\n.bg-primary {\n  background-color: white !important;\n}\n\n/*Navigation*/\n\n/*Logo img*/\n\njhi-navbar > nav > a > span {\n  background: url(https://kate-e.emea.porsche.biz/content/555295b649c93dda5e90268da4f0a5c9.svg);\n  width: 123px !important;\n  height: 75px !important;\n  cursor: auto;\n}\n\n.navbar-brand.logo {\n  margin-right: 0;\n}\n\n/*Hide text next to logo img*/\n\n.navbar-title,\n.navbar-version {\n  display: none;\n}\n\n/*Align navbar to left*/\n\nnav.navbar.navbar-primary {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.navbar-collapse.collapse {\n  align-self: flex-start;\n  margin-top: 20px;\n}\n\n/* Align Login to right */\n.collapse.right-alligned {\n  align-self: flex-end;\n  margin-top: -32px;\n  margin-right: 5px;\n}\n\n/*Remove icons next to navbar elements*/\n\n.navbar .ng-fa-icon,\n.dropdown-toggle:after {\n  display: none;\n}\n\n/*Styling of navigation items*/\n\n.nav-item.pointer.active.dropdown a,\n.nav-item.pointer.dropdown a,\n.navbar-nav.ml-auto li,\n.aNB.navbar-brand.logo {\n  font-weight: 400 !important;\n  color: #000 !important;\n  font-size: 1rem;\n}\n\n.nav-item.pointer.active.dropdown a:hover,\n.nav-item.pointer.dropdown a:hover,\n.navbar-nav.ml-auto li:hover,\n.aNB.navbar-brand.logo:hover {\n  color: #d5001c !important;\n}\n\n.nav-item {\n  padding-bottom: 0.58rem;\n}\n\n.nav-item.active {\n  border-bottom: 2px solid #d5001c;\n}\n\n/*Styling of navigation dropdowns */\n\nul.dropdown-menu.show li a.dropdown-item,\nul.dropdown-menu.show li a.dropdown-item.active {\n  display: block;\n  padding: 0.625em 0.9375em;\n  font-weight: 400;\n  border-bottom: 1px solid #e3e4e4;\n  transition: background-color 0.24s, color 0.24s, border-color 0.24s;\n  background-color: #fff !important;\n}\n\nul.dropdown-menu.show li a.dropdown-item:hover,\nul.dropdown-menu.show li a.dropdown-item:hover,\nul.dropdown-menu.show li a.dropdown-item.active:hover,\n.nav-item.pointer.active.show.dropdown ul a:hover {\n  background-color: #d5001c !important;\n  color: #fff !important;\n}\n\nul.dropdown-menu.show {\n  padding: 0;\n  margin-top: 10px;\n}\n\n/*Header*/\n\n/*Align elements of header*/\n\nh2 {\n  display: flex;\n  flex-direction: column;\n}\n\n/*Styling of header line */\n\njhi-audit h2,\njhi-logs > .table-responsive > h2,\njhi-configuration > div > h2,\nh2 > span {\n  background-color: #f2f2f2;\n  width: calc(100% + 40px);\n  padding: 10px 30px;\n  margin: 0 -20px 10px;\n  font-size: 24px;\n}\n\n.component-title {\n  padding: 20px 30px !important;\n  font-weight: 300;\n}\n\n/*Align header with navigation */\n\n.jh-card {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n/*Home*/\n\n/*Remove all text elements*/\n\njhi-home > .row > .col-md-3 {\n  display: none;\n}\n\njhi-home > .row > .col-md-9 h1,\njhi-home > .row > .col-md-9 div,\njhi-home > .row > .col-md-9 p,\njhi-home > .row > .col-md-9 ul {\n  display: none;\n}\n\n/*Styling of text elements on login modal */\n\njhi-home .alert.alert-warning,\njhi-login-modal .alert.alert-warning {\n  background-color: #e3e4e5;\n}\n\njhi-home .alert.alert-warning a:hover,\njhi-login-modal .alert.alert-warning a:hover {\n  color: #000;\n  font-weight: bold;\n}\n\njhi-home .alert.alert-warning,\njhi-home .alert.alert-warning a,\njhi-login-modal .alert.alert-warning,\njhi-login-modal .alert.alert-warning a {\n  font-size: 14px;\n  color: #000 !important;\n  font-family: PorscheNextWLa, Arial Narrow, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  line-height: 1.5;\n}\n\n/*Buttons&Badges*/\n\n/*General*/\n\n.btn,\n.swal2-styled.swal2-cancel {\n  border-radius: 0px !important;\n}\n\n/*Primary button red/white*/\n\n.btn.btn-primary,\n.btn.btn-danger,\njhi-body-planing-detail .btn.btn-success-green {\n  border-radius: 0px !important;\n  color: #fff;\n  background-color: #d5001c;\n  border: 1px solid #d5001c;\n  box-shadow: none;\n  width: auto !important;\n  height: auto !important;\n  padding: 0.375rem 0.75rem !important;\n}\n\n.btn.btn-primary:hover,\n.btn.btn-primary:active,\n.btn.btn-primary:focus,\n.btn-primary:not(:disabled):not(.disabled):active,\n.btn.btn-danger:active,\n.btn.btn-danger:focus,\n.btn.btn-danger:hover,\njhi-body-planing-detail .btn.btn-success-green:hover {\n  background-color: #950014;\n  color: #fff;\n  border-color: #950014;\n  box-shadow: none !important;\n}\n\n.btn.btn-danger:disabled {\n  color: #fff;\n  background-color: #d5001c;\n  border: 1px solid #d5001c;\n}\n\nbutton.btn.btn-primary.btn-sm:disabled,\nbutton.btn.btn-grey.btn-sm:disabled,\nbutton.btn.btn-warning.btn-sm:disabled,\nbutton.btn.btn-primary.btn-sm:hover:disabled,\nbutton.btn.btn-grey.btn-sm:hover:disabled,\nbutton.btn.btn-warning.btn-sm:hover:disabled {\n  color: #323639;\n  background-color: #fff !important;\n  border-color: #323639;\n  opacity: 0.3;\n}\n\n/*Seconday button white/black*/\n\n.btn.btn-info,\n.btn.btn-primary.btn-sm,\n.btn.btn-info.btn-sm,\n.btn.btn-success-green,\n.btn.btn-blue.btn-sm,\n.btn.btn-grey.btn-sm,\n.swal2-confirm.swal2-styled,\n.btn.btn-secondary,\n.table-responsive.createBox .btn.btn-danger,\n.btn.btn-secondary,\n.swal2-styled.swal2-cancel {\n  color: #323639;\n  background-color: #fff;\n  border-color: #323639;\n  transition: all 0.2s;\n  width: auto !important;\n  height: auto !important;\n  padding: 0.375rem 0.75rem !important;\n}\n\njhi-c-nr-vds-type-code-exception .btn.btn-success-green {\n  color: #fff;\n  background-color: #018a16;\n  border: none !important;\n  width: auto !important;\n  height: auto !important;\n  padding: 0.375rem 0.75rem !important;\n}\n\njhi-c-nr-vds-type-code-exception .btn.btn-success-green:hover {\n  background-color: #018a16;\n  color: #fff;\n}\n\n.btn.btn-info:hover,\n.btn.btn-info.btn-sm:hover,\n.btn.btn-primary.btn-sm:hover,\n.btn.btn-info.btn-sm:hover,\n.btn.btn-blue.btn-sm:hover,\n.btn.btn-grey.btn-sm:hover,\n.btn.btn-success-green:hover,\n.swal2-confirm.swal2-styled:hover,\n.btn-info:not(:disabled):not(.disabled):active:focus,\n.btn-secondary:not(:disabled):not(.disabled):active,\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\n.btn.btn-secondary:hover,\n.table-responsive.createBox .btn.btn-danger:hover,\n.btn.btn-secondary:hover {\n  background-color: #fff;\n  color: #d5001c;\n  border-color: #d5001c;\n  box-shadow: none;\n}\n\n/* Black Button */\n\nh2 .btn.btn-primary.float-right.jh-create-entity,\n.btn.btn-warning.btn-sm:active,\n.btn.btn-warning.btn-sm:focus,\n.btn.btn-grey.btn-sm:active,\n.btn.btn-grey.btn-sm:focus {\n  border-radius: 0;\n  min-width: 3rem;\n  min-height: 3rem;\n  width: fit-content;\n  background-color: #323639;\n  border: 1px solid #323639;\n  color: #fff;\n  align-self: flex-end;\n  box-shadow: none !important;\n  margin-top: -72px;\n}\n\nh2 .btn.btn-primary.float-right.jh-create-entity:hover,\n.btn.btn-warning.btn-sm:hover,\n.swal2-styled.swal2-cancel:hover {\n  background-color: #d5001c !important;\n  color: #fff;\n  border-color: #d5001c;\n}\n\n/*Layout btn group*/\n.btn-group > .btn-sm {\n  margin-top: 0px;\n  min-width: 3rem !important;\n  min-height: 3rem !important;\n  font-size: 16px;\n}\n\n.btn-sm,\n.btn-danger,\n.btn.btn-info {\n  margin-top: 0px;\n  font-size: 15px;\n  padding: 0px;\n}\n\n.btn-group > .btn-sm,\n.btn-group.btn.btn-info.btn-sm {\n  margin: 0 10px 0 0;\n}\n\n.btn.focus,\nbutton:focus {\n  outline: 0 !important;\n  box-shadow: none;\n}\n\n.btn.btn-info.btn-sm > .d-none.d-md-inline,\n.btn > .d-none.d-md-inline {\n  display: none !important;\n}\n\n.create-planing-circle-data {\n  font-size: 16px;\n}\n\n.btn.btn-danger.float-right.jh-create-entity.create-planing-circle-data > fa-icon,\n.btn.btn-success-green.float-right.jh-create-entity.create-planing-circle-data > fa-icon {\n  padding-right: 5px;\n}\n\n.btn.btn-danger.float-right.jh-create-entity.create-planing-circle-data {\n  width: auto !important;\n  padding: 0.375rem 0.75rem;\n  height: auto;\n}\n\n.swal2-styled.swal2-cancel,\n.swal2-confirm.swal2-styled {\n  font-size: 16px !important;\n}\n\njhi-type-e > div > .btn.btn-info.btn-sm,\njhi-model-e > div > .btn.btn-info.btn-sm {\n  margin-bottom: 2px !important;\n}\n\njhi-type-e > div > .btn.btn-danger,\njhi-model-e > div > .btn.btn-danger,\njhi-monitoring .btn.btn-danger {\n  height: 2em;\n  width: 2em;\n  padding: 0px;\n  margin-bottom: 2px !important;\n  border: 1px solid #d5001c;\n}\n\njhi-logs .btn,\njhi-logs .btn.btn-sm.btn-warning {\n  width: auto !important;\n  height: auto !important;\n  padding: 0px;\n}\n\njhi-logs .btn.btn-sm,\njhi-logs .btn.btn-info.btn-sm {\n  color: #212529;\n  padding: 0px !important;\n}\n\n.badge {\n  border-radius: 0;\n  font-size: 12px;\n}\n\n.badge.badge-warning {\n  background-color: #ff9b00;\n}\n\n.badge.badge-danger {\n  background-color: #e00000;\n}\n\n.badge.badge-success {\n  background-color: #018a16;\n}\n\n.badge {\n  background-color: #b0b1b2;\n}\n\n/*Table*/\n\nhr {\n  display: none;\n}\n\ntable {\n  height: auto;\n  table-layout: fixed;\n}\n\n.table-responsive {\n  margin-top: 30px;\n  word-break: break-word;\n  width: 100%;\n  height: auto;\n  position: relative !important;\n  overflow: unset;\n}\n\ntbody {\n  border-bottom: 0;\n}\n\ntbody::-webkit-scrollbar {\n  width: 10px;\n}\n\ntbody::-webkit-scrollbar-thumb {\n  border-radius: 16px;\n  background-color: rgba(0, 0, 0, 0.5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n\ntbody::-webkit-scrollbar-track {\n  background-color: #fff;\n}\n\nthead {\n  display: block;\n}\n\n.table thead tr th {\n  font-weight: 400;\n  color: #000;\n  background-color: #eff0f1 !important;\n  word-break: break-all;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\njhi-monitoring .table tr,\njhi-body-planing-data .table tr {\n  width: 100%;\n  display: table-row;\n  table-layout: auto;\n}\n\nth > span {\n  padding-right: 5px;\n}\n\n.table-responsive td {\n  background-color: #fff;\n  vertical-align: middle;\n}\n\n.table-responsive th {\n  border: 0px !important;\n}\n\n/*Pagination*/\n\njhi-item-count {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  background-color: white;\n}\n\nngb-pagination {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.row.justify-content-center,\n.pagination .page-link {\n  background-color: #eff0f1 !important;\n  color: #848484 !important;\n}\n\n.page-item.active a {\n  border-bottom: 2px solid #d5001c !important;\n}\n\n.info.jhi-item-count {\n  padding: 10px;\n}\n\n.pagination {\n  margin: 0;\n  padding: 8px;\n}\n\n.page-link:focus {\n  box-shadow: none;\n}\n\n/*Footer*/\n\n.footer {\n  margin-top: 50px;\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n  font-size: 16px;\n}\n\n/* Form Elements */\n\ninput,\nselect,\n.form-control {\n  border-radius: 0 !important;\n  /* padding: .429em 32px .429em .429em; */\n  color: #000;\n  border: 1px solid #a6a6a6 !important;\n  font-size: 16px;\n  /* max-height: 2em; */\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\ninput:focus,\nselect:focus {\n  outline: none;\n  box-shadow: none;\n  border: 1px solid #a6a6a6 !important;\n  background-color: #fff;\n  outline: 0;\n  box-shadow: none !important;\n}\n\ninput:-internal-autofill-selected {\n  background-color: #fff !important;\n}\n\n.col-8 > .ng-untouched.ng-pristine.ng-valid {\n  border: none !important;\n}\n\n/* Search */\n\njhi-search-vehicle .normal-component-title,\njhi-search-vehicle-multiple .normal-component-title,\njhi-lock-vin .normal-component-title,\njhi-reserve-vin .normal-component-title,\njhi-manual-vin-adjustment .normal-component-title,\njhi-search-archived-vehicle .normal-component-title,\njhi-monitoring .normal-component-title {\n  font-weight: 300;\n}\n\njhi-search-vehicle .component-description,\njhi-search-vehicle-multiple .component-description,\njhi-reserve-vin .component-description,\njhi-manual-vin-adjustment .component-description,\njhi-search-archived-vehicle .component-description {\n  background-color: transparent;\n  font-size: 16px;\n  margin-top: -10px;\n  margin-bottom: 0px;\n}\n\njhi-search-vehicle h4,\njhi-search-vehicle-multiple h4,\njhi-search-archived-vehicle h4,\njhi-manual-vin-adjustment h4 {\n  padding-bottom: 20px;\n}\n\njhi-search-vehicle .row {\n  display: flex;\n  align-items: center;\n}\n\njhi-search-vehicle-multiple .row {\n  display: flex;\n  align-items: center;\n}\n\n.row > .form-group.col-2.offset-4.text-right {\n  margin: 0px;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.form-group.col-2.offset-4.text-right > .btn {\n  margin-right: 10px;\n}\n\n/* Planing-circle-data */\n\n.controls-container {\n  align-self: flex-end;\n  margin-top: -67px;\n}\n\nspan.float-right.spinner {\n  margin-top: -15px;\n}\n\n/*Update & Detail View/\n\t\t/*Body Planning*/\n/*CNr-VDS-Typecode-Exception*/\n/*CNr&VDS*/\n/*Model*/\n\n/*Modelyear*/\n\nspan.jhi-modelyear-info {\n  background-color: transparent;\n  font-size: 16px;\n  margin-top: 15px;\n  margin-bottom: -25px;\n}\n\nli.jhi-modelyear-info {\n  background-color: transparent;\n  font-size: 16px;\n  margin-top: 15px;\n  margin-bottom: -25px;\n}\n\n\n/*Password*/\n/*Plant*/\n/*Settings*/\n/*Type*/\n\njhi-body-planing-data-update h2 > span,\njhi-body-planing-data-update h2,\njhi-body-planing-update h2 > span,\njhi-body-planing-update h2,\njhi-body-planing-detail h2 > span,\njhi-body-planing-detail h2,\njhi-body-planing-data-detail h2 > span,\njhi-body-planing-data-detail h2,\njhi-c-nr-vds-type-code-exception-update h2 > span,\njhi-c-nr-vds-type-code-exception-update h2,\njhi-c-nr-vds-type-code-exception-detail h2 > span,\njhi-c-nr-vds-type-code-exception-detail h2,\njhi-c-nr-vds-type-code-update h2 > span,\njhi-c-nr-vds-type-code-update h2,\njhi-c-nr-vds-type-code-detail h2 > span,\njhi-c-nr-vds-type-code-detail h2,\njhi-model-e-update h2 > span,\njhi-model-e-update h2,\njhi-model-e-detail h2 > span,\njhi-model-e-detail h2,\njhi-model-year-update h2 > span,\njhi-model-year-update h2,\njhi-model-year-detail h2 > span,\njhi-model-year-detail h2,\njhi-password h2,\njhi-plant-update h2 > span,\njhi-plant-update h2,\njhi-plant-detail h2 > span,\njhi-plant-detail h2,\njhi-settings h2,\njhi-type-e-update h2 > span,\njhi-type-e-update h2,\njhi-type-e-detail h2 > span,\njhi-type-e-detail h2 {\n  display: flex;\n  flex-direction: row;\n  font-size: 24px;\n  margin: 0px;\n  padding: 0px;\n  width: fit-content;\n}\n\njhi-body-planing-data-update h2 > span,\njhi-body-planing-update h2 > span,\njhi-body-planing-detail h2 > span,\njhi-body-planing-data-detail h2 > span,\njhi-c-nr-vds-type-code-exception-update h2 > span,\njhi-c-nr-vds-type-code-exception-detail h2 > span,\njhi-c-nr-vds-type-code-update h2 > span,\njhi-c-nr-vds-type-code-detail h2 > span,\njhi-model-e-update h2 > span,\njhi-model-e-detail h2 > span,\njhi-model-year-update h2 > span,\njhi-model-year-detail h2 > span,\njhi-plant-update h2 > span,\njhi-plant-detail h2 > span,\njhi-type-e-update h2 > span,\njhi-type-e-detail h2 > span {\n  padding-right: 10px;\n}\n\njhi-body-planing-data-update .row.justify-content-center,\njhi-body-planing-update .row.justify-content-center,\njhi-body-planing-detail .row.justify-content-center,\njhi-body-planing-data-detail .row.justify-content-center,\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center,\njhi-c-nr-vds-type-code-exception-detail .row.justify-content-center,\njhi-c-nr-vds-type-code-update .row.justify-content-center,\njhi-c-nr-vds-type-code-detail .row.justify-content-center,\njhi-model-e-update .row.justify-content-center,\njhi-model-e-detail .row.justify-content-center,\njhi-model-year-update .row.justify-content-center,\njhi-model-year-detail .row.justify-content-center,\njhi-password .row.justify-content-center,\njhi-plant-update .row.justify-content-center,\njhi-plant-detail .row.justify-content-center,\njhi-settings .row.justify-content-center,\njhi-type-e-update .row.justify-content-center,\njhi-type-e-detail .row.justify-content-center {\n  padding-top: 10px;\n  padding-bottom: 20px;\n}\n\njhi-body-planing-data-update dl,\njhi-body-planing-detail dl,\njhi-body-planing-data-detail dl,\njhi-c-nr-vds-type-code-exception-detail dl,\njhi-model-e-detail dl,\njhi-model-year-detail dl,\njhi-plant-detail dl,\njhi-type-e-detail dl {\n  color: #000;\n  font-size: 16px;\n  margin-top: 16px;\n}\n\njhi-body-planing-data-update button,\njhi-body-planing-update button,\njhi-body-planing-detail button,\njhi-body-planing-data-detail button,\njhi-c-nr-vds-type-code-exception-update button,\njhi-c-nr-vds-type-code-exception-detail button,\njhi-c-nr-vds-type-code-update button,\njhi-c-nr-vds-type-code-detail button,\njhi-model-e-update button,\njhi-model-e-detail button,\njhi-model-year-update button,\njhi-model-year-detail button,\njhi-plant-update button,\njhi-plant-detail button,\njhi-typel-e-update button,\njhi-model-e-detail button {\n  margin-right: 8px;\n}\n\njhi-body-planing-data-update .ng-fa-icon,\njhi-body-planing-update .ng-fa-icon,\njhi-body-planing-detail .ng-fa-icon,\njhi-body-planing-data-detail .ng-fa-icon,\njhi-c-nr-vds-type-code-exception-update .ng-fa-icon,\njhi-c-nr-vds-type-code-exception-detail button .ng-fa-icon,\njhi-c-nr-vds-type-code-update .ng-fa-icon,\njhi-c-nr-vds-type-code-detail button .ng-fa-icon,\njhi-model-e-update .ng-fa-icon,\njhi-model-e-detail button .ng-fa-icon,\njhi-model-year-update button > .ng-fa-icon,\njhi-model-year-detail button > .ng-fa-icon,\njhi-plant-update button > .ng-fa-icon,\njhi-plant-detail button > .ng-fa-icon,\njhi-type-e-update .ng-fa-icon,\njhi-type-e-detail button .ng-fa-icon {\n  display: none;\n}\n\njhi-body-planing-data-update .fDivRow,\njhi-model-e-update .fDivRow,\njhi-model-year-update .fDivRow,\njhi-plant-update .fDivRow,\njhi-type-e-update .fDivRow {\n  margin-top: 16px;\n  padding-bottom: 16px;\n}\n\njhi-body-planing-data-update .form-control-label,\njhi-body-planing-update .form-control-label,\njhi-body-planing-detail .form-group label,\njhi-c-nr-vds-type-code-exception-update .form-control-label,\njhi-c-nr-vds-type-code-exception-update .form-group label,\njhi-c-nr-vds-type-code-update .form-control-label,\njhi-c-nr-vds-type-code-update .form-group label,\njhi-model-e-update .form-control-label,\njhi-model-e-update .form-group label,\njhi-model-year-update .form-control-label,\njhi-model-year-update .form-group label,\njhi-password label,\njhi-plant-update .form-control-label,\njhi-plant-update .form-group label,\njhi-settings label,\njhi-type-e-update .form-control-label,\njhi-type-e-update .form-group label {\n  color: #000;\n  font-size: 16px;\n}\n\njhi-body-planing-data-update .form-group,\njhi-model-e-update .form-group,\njhi-model-year-update .form-group,\njhi-password .form-group,\njhi-plant-update .form-group,\njhi-settings .form-group,\njhi-type-e-update .form-group {\n  padding-top: 8px;\n}\n\njhi-body-planing-data-update .alert.alert-danger.alert-dismissible,\njhi-body-planing-update .alert.alert-danger.alert-dismissible,\njhi-c-nr-vds-type-code-exception-update .alert.alert-danger.alert-dismissible,\njhi-c-nr-vds-type-code-update .alert.alert-danger.alert-dismissible,\njhi-model-e-update .alert.alert-danger.alert-dismissible,\njhi-model-year-update .alert.alert-danger.alert-dismissible,\njhi-plant-update .alert.alert-danger.alert-dismissible,\njhi-type-e-update .alert.alert-danger.alert-dismissible {\n  margin-top: 16px;\n  background-color: #e00000;\n}\n\n.modal-content {\n  border-radius: 0px;\n}\n\njhi-model-e-update .btn.btn-danger,\njhi-model-e-update .fDivCol .btn.btn-primary,\njhi-model-e .table-responsive.createBox .btn.btn-danger,\njhi-model-year-update .btn.btn-danger,\njhi-model-year-update .fDivCol .btn.btn-primary,\njhi-type-e-update .btn.btn-danger,\njhi-type-e-update .fDivCol .btn.btn-primary,\njhi-type-e .fDivCol.pT5 .btn.btn-primary.btn-sm {\n  display: none;\n}\n\njhi-password-strength-bar div {\n  color: #000;\n  margin-top: 16px;\n}\n\njhi-model-e .table-responsive.createBox,\njhi-type-e .table-responsive.createBox {\n  background-color: #f2f2f2;\n  width: calc(100% + 40px);\n  padding: 10px 20px;\n  margin: 0 -20px 80px;\n  font-size: 24px;\n  border: none;\n}\n\njhi-model-e .table-responsive.createBox .d-none.d-md-inline,\njhi-type-e .table-responsive.createBox .d-none.d-md-inline {\n  font-size: 24px;\n  margin: 0px;\n  padding: 0px;\n  width: fit-content;\n}\n\njhi-model-e .table-responsive.createBox label,\njhi-type-e .table-responsive.createBox label {\n  color: #000;\n  font-size: 16px;\n}\n\n.table-responsive.createBox .btn.btn-primary .ng-fa-icon,\n.table-responsive.createBox .btn.btn-secondary .ng-fa-icon,\n.table-responsive.createBox .btn.btn-primary .ng-fa-icon,\n.table-responsive.createBox .btn.btn-secondary .ng-fa-icon {\n  display: none;\n}\n\njhi-model-e .table-responsive.createBox .form-text.text-danger,\njhi-type-e .table-responsive.createBox .form-text.text-danger {\n  font-size: 12px;\n}\n\njhi-model-e-update .col-8 > .ng-untouched.ng-pristine.ng-valid,\njhi-type-e-update .col-8 > .ng-untouched.ng-pristine.ng-valid {\n  border: 0px;\n}\n\njhi-type-e .table-responsive.createBox .btn.btn-danger {\n  display: none;\n}\n\njhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(4) label,\njhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(5) label,\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(6) label,\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(7) label,\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(8) label {\n  white-space: nowrap;\n  margin-bottom: 0;\n  width: 100px;\n}\n\njhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(4),\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(6) {\n  padding-top: 20px;\n}\n\njhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(5),\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(8) {\n  padding-bottom: 20px;\n}\n\njhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(4),\njhi-c-nr-vds-type-code-update .row.justify-content-center .col-8 form div .form-group:nth-child(5),\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(6),\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(7),\njhi-c-nr-vds-type-code-exception-update .row.justify-content-center .col-8 form div .form-group:nth-child(8) {\n  display: flex;\n  align-items: center;\n}\n\njhi-c-nr-vds-type-code-update select {\n  max-height: none;\n}\n\njhi-body-planing-data h2 span:first-child {\n  margin-bottom: 20px;\n}\n\njhi-body-planing-data h2 span:nth-child(2n) {\n  margin-bottom: 10px;\n}\n\njhi-body-planing-data > div > .btn.btn-info.btn-sm {\n  position: absolute;\n  margin-top: 20px;\n  margin-left: 340px;\n  display: flex;\n  align-self: flex-end;\n}\n\n/* Model-e */\n\njhi-model-e .table-responsive,\njhi-type-e .table-responsive {\n  margin-top: 10px;\n}\n\njhi-planing-circle-data .table-responsive,\njhi-body-planing-data .table-responsive {\n  margin-top: -10px;\n}\n\n.search-box {\n  margin-top: 25px;\n}\n\ninput#searchTextId {\n  height: 36px;\n  top: -1px;\n  position: relative;\n}\n\n/*Lock VIN*/\n\njhi-lock-vin div h4 select {\n  margin-top: 15px;\n  margin-bottom: 20px;\n  width: 20% !important;\n}\n\njhi-lock-vin .not-available-title,\njhi-reserve-vin .not-available-title {\n  margin-bottom: 10px;\n  margin-top: -10px;\n}\n\njhi-lock-vin div form .row:nth-child(1) {\n  padding-top: 40px !important;\n}\n\njhi-lock-vin div form .row:nth-child(3) {\n  padding-bottom: 40px !important;\n}\n\njhi-lock-vin div form .row {\n  background-color: #f2f2f2;\n}\n\njhi-lock-vin .mb-2 {\n  margin-bottom: 0 !important;\n}\n\n/*Reserve VIN*/\n/*Lock VIN*/\n\njhi-lock-vin h4 span,\njhi-reserve-vin h4 span {\n  font-weight: 400;\n}\n\njhi-reserve-vin div h4 select {\n  margin-top: 15px;\n  margin-bottom: 20px;\n  width: 20% !important;\n}\n\njhi-reserve-vin div form .row:nth-child(1) {\n  padding-top: 40px !important;\n}\n\njhi-reserve-vin div form .row:nth-child(3) {\n  padding-bottom: 40px !important;\n}\n\njhi-reserve-vin div form .row {\n  background-color: #f2f2f2;\n}\n\njhi-reserve-vin .mb-2 {\n  margin-bottom: 0 !important;\n}\n\n/* Body-Planing-Data */\n.title-container {\n  background-color: #f2f2f2;\n  width: calc(100% + 40px);\n  padding: 20px 30px;\n  margin: 0 -20px 10px;\n  font-size: 24px;\n}\n\n/*Monitoring*/\n\njhi-monitoring .columnDiv {\n  border: none;\n  padding-top: 20px;\n  height: fit-content;\n}\n\njhi-monitoring h2 img {\n  display: none;\n}\n\njhi-monitoring .autocomplete-container {\n  margin-top: 10px;\n}\n\n/*User Management*/\n\njhi-user-mgmt .btn.btn-success.btn-sm {\n  padding-right: 8px;\n  padding-left: 8px;\n  background-color: #000;\n  border: none;\n}\n\njhi-user-mgmt .btn.btn-success.btn-sm:hover {\n  background-color: #d5001c;\n}\n\n/*Audit*/\n\njhi-audit .input-group.mb-3 {\n  align-items: center;\n}\n\njhi-audit .input-group-text {\n  border-radius: 0;\n  max-height: 2em;\n}\n\n/*Modal*/\n\n.swal2-popup.swal2-modal,\n.modal-body,\n.modal-header,\n.swal2-html-container {\n  border-radius: 0px;\n  padding: 15px;\n}\n\n.modal-body {\n  margin-top: 20px;\n}\n\n.swal2-popup.swal2-modal.swal2-icon-warning.swal2-show {\n  padding: 0px;\n}\n\n.swal2-icon.swal2-warning.swal2-icon-show {\n  display: none !important;\n}\n\n.modal-body > .row.justify-content-center {\n  margin: 0;\n  background-color: #fff !important;\n}\n\nh2.swal2-title,\n.swal2-html-container {\n  font-size: 16px;\n  display: flex !important;\n  align-self: start;\n  margin: 0px;\n}\n\n.swal2-header,\n.modal-header {\n  background-color: #f4f4f4;\n  color: #000;\n  padding: 1em;\n  font-weight: 700;\n  border-bottom: 0;\n}\n\n.swal2-html-container {\n  margin-top: 40px;\n  margin-bottom: 40px;\n  font-size: 16px;\n}\n\n.swal2-content {\n  border-top: 1px solid #c8c8c8;\n  border-bottom: 1px solid #c8c8c8;\n  padding: 1em;\n}\n\n.swal2-actions {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n.form-check {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.modal-content {\n  border-radius: 0px;\n}\n\n.modal-footer .btn.btn-secondary .ng-fa-icon,\n.modal-footer .btn.btn-danger .ng-fa-icon {\n  display: none;\n}\n\n.swal2-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end !important;\n}\n\n.swal2-cancel.swal2-styled {\n  margin-right: 15px;\n}\n\n.swal2-confirm.swal2-styled,\n.swal2-styled:focus {\n  border-radius: 0px !important;\n  color: #fff !important;\n  background-color: #d5001c !important;\n  border: 1px solid #d5001c !important ;\n  box-shadow: none !important;\n  background-image: none !important;\n}\n\n.swal2-confirm.swal2-styled:hover {\n  background-color: #950014 !important;\n  color: #fff;\n  border-color: #950014 !important;\n  box-shadow: none;\n}\n\n.swal2-cancel.swal2-styled {\n  border-radius: 0;\n  color: #323639 !important;\n  background-color: #fff !important;\n  border: 1px solid !important;\n  border-color: #323639 !important;\n  transition: all 0.2s;\n}\n\n.swal2-cancel.swal2-styled:hover {\n  background-color: #fff !important;\n  color: #d5001c !important;\n  border-color: #d5001c !important;\n  border-radius: 0px !important;\n  box-shadow: none;\n  background-image: none !important;\n}\n\n/*Alert*/\n\n.alert {\n  border-radius: 0px !important;\n  margin-top: 15px;\n}\n\n.alert.alert-warning {\n  margin-top: 16px;\n  background-color: #e00000;\n  border-radius: 0px !important;\n}\n\n/* Autocomplete fields */\n.p-autocomplete .p-autocomplete-dropdown.p-button {\n  min-height: 34px;\n  min-width: 29px;\n  width: 1rem;\n  height: 1rem;\n  border-color: #a6a6a3 !important;\n  background-color: #fff;\n  transition: all 0.2s;\n  border: 1px solid;\n  border-left: 0;\n}\n\n.p-button.p-button-icon-only .p-button-text {\n  padding: 0.429em;\n}\n\ninput.p-inputtext.p-widget.ui-state-default.ui-corner-all.p-autocomplete-input {\n  min-width: 225px;\n}\n\np-autocomplete {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.p-autocomplete-items .p-autocomplete-list-item {\n  margin: 0;\n  padding: 0.429em 0.857em;\n  border: 0;\n  color: #000;\n  border-radius: 0;\n}\n\nli.p-autocomplete-list-item.p-highlight {\n  color: white;\n  background-color: #d5001c;\n}\n\nul.p-autocomplete-items.p-autocomplete-list.p-widget-content.p-widget.ui-corner-all.p-helper-reset {\n  background-color: white;\n}\n\nngb-modal-window {\n  z-index: 1060 !important;\n}\n\n.p-autocomplete-items {\n  background-color: white;\n  border: 1px solid grey;\n}\n\n.p-autocomplete-item {\n  padding: 5px;\n  margin: 0;\n}\n\n.p-autocomplete-item:hover {\n  background-color: #E0E0E0;\n}\n\n.btn-close {\n  background-color: white;\n  opacity: 40%;\n  border: none;\n}\n\n.btn-close:hover {\n  opacity: 30%;\n}\n\n.btn-close:before {\n  content: \"X\";\n  padding: 2px;\n  margin-left: auto;\n  order: 2;\n}\n\nngb-alert {\n  display: grid !important;\n  grid-template-columns: 95% 5% !important;\n  padding: 10px 0 10px 10px !important;\n}\n\nul.p-autocomplete-multiple-container.p-component.p-inputtext.ng-star-inserted {\n  padding-left: 5px;\n  margin-bottom: 0 !important;\n  border: 1px solid grey;\n}\n\nul.p-autocomplete-multiple-container.p-component.p-inputtext.ng-star-inserted .p-autocomplete-token {\n  border: 1px solid lightgrey;\n  padding-right: 3px;\n  padding-left: 3px;\n  margin-right: 5px;\n}\n\nul.p-autocomplete-multiple-container.p-component.p-inputtext.ng-star-inserted .p-autocomplete-token .p-autocomplete-token-label {\n  margin-right: 15px;\n  font-size: 14px;\n}\nli.p-autocomplete-input-chip input.p-autocomplete-input {\n    border: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
